import { getTmxId } from './general';
import { generateUUID } from './utils';

export interface IApiHeaders {
  [key: string]: string;
}

export interface IHeaderOptions {
  useOriginHeader?: boolean; // Some APIs use 'origin', others use 'ClientOrigin'
}

/**
 * Creates standardized headers for API calls
 * @param jwt - JWT token for authorization
 * @param options - Configuration options for header customization
 * @returns Headers object with common API headers
 */
export const createApiHeaders = (jwt: string, options: IHeaderOptions = {}): IApiHeaders => {
  const { useOriginHeader = false } = options;

  const userAgent = typeof window !== 'undefined' && typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const tmxProfileId = getTmxId();

  const headers: IApiHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'user-agent': userAgent,
    TMXProfileID: tmxProfileId,
    'x-trace-uuid': generateUUID(),
    channelID: '2', // MCMMOBILE for mobile devices
    Authorization: jwt,
  };

  // Add origin header based on API requirements
  if (useOriginHeader) {
    headers.origin = origin;
  } else {
    headers.ClientOrigin = origin;
  }

  return headers;
};

/**
 * Creates headers specifically for OTP API calls
 * @param jwt - JWT token for authorization
 * @returns Headers object configured for OTP APIs
 */
export const createOTPHeaders = (jwt: string): IApiHeaders => {
  return createApiHeaders(jwt, { useOriginHeader: true });
};

/**
 * Creates headers specifically for Auth API calls
 * @param jwt - JWT token for authorization
 * @returns Headers object configured for Auth APIs
 */
export const createAuthHeaders = (jwt: string): IApiHeaders => {
  return createApiHeaders(jwt, { useOriginHeader: false });
};
